import React from 'react';

import { Hero, Intro, Statements } from './components';

export const PrivacyWeb = () => (
  <>
    <Hero />
    <Intro />
    <Statements />
  </>
);

export default PrivacyWeb;
